import { Hero } from "@/components/home/Hero";
import { Intro } from "@/components/home/Intro";
import { Services } from "@/components/home/Services";
import { Automation } from "@/components/home/Automation";
import { Process } from "@/components/home/Process";
import { FeaturedProjects } from "@/components/home/FeaturedProjects";
import { WhyUs } from "@/components/home/WhyUs";
import { Partners } from "@/components/home/Partners";
import { CTA } from "@/components/home/CTA";
import { ContactSection } from "@/components/home/ContactSection";
import { useSettings } from "@/hooks/useContent";
import { useSeo } from "@/components/shared/useSeo";

export default function Home() {
  const { data: settings } = useSettings();
  useSeo({
    title: "Sistem Elektrik ve Mühendislik | Endüstriyel Elektrik & Otomasyon",
    description: "Endüstriyel elektrik, otomasyon, elektrik taahhüt, pano sistemleri ve mühendislik projelerinde uçtan uca, güvenilir çözümler.",
    canonical: "https://sistemmuhendislik.com/",
  });

  return (
    <>
      <Hero settings={settings} />
      <Intro />
      <Services />
      <Automation />
      <Process />
      <FeaturedProjects />
      <WhyUs />
      <Partners />
      <CTA />
      <ContactSection />
    </>
  );
}
